export default __webpack_public_path__ + "864c76bbf92b64fb9376c307d5084404.svg";